module.exports = __webpack_public_path__ + "static/media/HOD.3d6cef74.JPG";